import React from 'react';
import { useSelector } from 'react-redux';

import { useToggle } from 'Shared/utils/hooks';
import WpButton from 'Wpds/components/button/WpButton';
import WpButtonGroup from 'Wpds/components/button/WpButtonGroup';
import { getGoalBySlug, getGoalById } from 'Shared/selectors/Goals.selectors';
import PageUrlsUtils from 'Shared/utils/PageUrls.utils';
import { WpModal, WpModalBody, WpModalFooter, WpModalHeader } from 'Wpds/components/modal';

import ConfirmAddSubGoalSection from './ConfirmAddSubGoalSection/ConfirmAddSubGoalSection';

type Props = {
  goalId: number;
  chosenGoalSlug: string;
  onToggle(): void;
  onSubmit: Function;
};

function ConfirmAddSubGoalModal({ goalId, chosenGoalSlug, onToggle, onSubmit }: Props) {
  const [isLoading, toggleIsLoading] = useToggle(false);

  const handleCancelClick = () => onToggle();

  const handleConfirmClick = () => {
    toggleIsLoading();
    onSubmit();
  };

  const newParentGoal = useSelector(state => getGoalById(state, { id: goalId })?.toJS());

  const chosenGoal = useSelector(state => getGoalBySlug(state, { slug: chosenGoalSlug })?.toJS());

  const chosenGoalParent = useSelector(state => getGoalById(state, { id: chosenGoal.parentId })?.toJS());

  return (
    <WpModal isOpen size="md" onToggle={onToggle} dismissOnBackdrop={false}>
      <WpModalHeader>Are you sure?</WpModalHeader>
      <WpModalBody>
        {chosenGoalParent && (
          <div className="mb-4">
            <ConfirmAddSubGoalSection
              fromTitle="Old Parent Goal"
              toTitle="New Parent Goal"
              fromBody={chosenGoalParent.name}
              toBody={newParentGoal.name}
            >
              <a href={PageUrlsUtils.makeGoalDetailPageUrl(chosenGoal.slug)} target="_blank" rel="noopener noreferrer">
                {chosenGoal.name}
              </a>
              &nbsp;already has a parent goal.{' '}
              <p>
                <b>Are you sure you want to update it’s parent goal?</b>
              </p>
            </ConfirmAddSubGoalSection>
          </div>
        )}
      </WpModalBody>
      <WpModalFooter>
        <WpButtonGroup>
          <WpButton variant="tertiary" onClick={handleCancelClick}>
            No, Cancel
          </WpButton>
          <WpButton qaTest="confirm-change-parent-modal-submit-button" loading={isLoading} onClick={handleConfirmClick}>
            Yes, Update
          </WpButton>
        </WpButtonGroup>
      </WpModalFooter>
    </WpModal>
  );
}

export default ConfirmAddSubGoalModal;
